export default __webpack_public_path__ + "static/standout-game-314c7e0fcc7f37bcc17923989591a177.webp";